<template>
  <section
    class="relative flex h-[400px] w-screen items-center justify-center overflow-hidden bg-[#1e1e1e] sm:h-[500px] md:h-[600px] lg:w-3/5 lg:rounded-b-4xl"
    aria-label="Loading featured content"
  >
    <div
      class="mx-4 w-full max-w-80 animate-pulse rounded-lg bg-[#181818] p-6 shadow-2xl sm:mx-8 sm:max-w-md sm:p-8 md:ml-16"
    >
      <!-- Date Placeholder -->
      <div class="mb-3 h-3 w-24 rounded bg-gray-700"></div>

      <!-- Title Placeholder -->
      <div class="mb-4 h-6 w-3/4 rounded bg-gray-600 sm:h-7 md:h-8"></div>

      <!-- Excerpt Placeholder -->
      <div class="space-y-2">
        <div class="h-3 w-full rounded bg-gray-700"></div>
        <div class="h-3 w-5/6 rounded bg-gray-700"></div>
        <div class="h-3 w-4/6 rounded bg-gray-700"></div>
      </div>

      <!-- CTA Button Placeholder -->
      <div class="mt-6 h-10 w-32 rounded-full bg-gray-700"></div>
    </div>
  </section>
</template>
